import React, { useEffect, useState } from 'react';
import Seeker from './Seeker';
import { APISERVICE } from '../../../services/api.service';
import { useSelector } from 'react-redux';
import { getDateFormatYMD } from '../home/logic';
import { formatDate } from 'utils';
import TableReport from '../../shared/report/TableReport';
import { ModalReportDetail } from '../../shared/report/ModalReportDetail';

const ReportTeacher = () => {

    const [reports, setReports] = useState([])
    const [showReportDetail, setShowReportDetail] = useState(false);
    const [report, setReport] = useState({})
    // Almacena los fechas de busqueda.
    const [search, setSearch] = useState(null)
    const [loading, setLoading] = useState(false)
    const teacher = useSelector(store => store.teacher.teacherInfo)

    useEffect(() => {
      searchTeacherReports({
        startDate: getDateFormatYMD(),
        endDate: getDateFormatYMD(),
        id: '',
      })
    },[])

    const searchTeacherReports = async ( body ) => {
      try {
        setLoading(true);
        const url = 'reporte/asistencia'
        const { success, report } = await APISERVICE.post(url, '' ,{...body, id: teacher.id});
          if(success){  
            setReports(report[0]);
            setSearch(body);
          }else{
            setReports([]);
          }
      } catch (error) {
        
      } finally {
        setLoading(false);
      }
    }
    
  return (
    <div className='contenedor reports'>
        <div className='title-enable-teacher fs-3'>Reportes</div>
        <Seeker searchTeacherReports={searchTeacherReports}/>
        {search&&(
          <div>
            Fecha: desde
            <span className='mx-1'>{formatDate(search.startDate, 'd/m/Y')}</span>
            - hasta
            <span className='mx-1'>{formatDate(search.endDate, 'd/m/Y')}</span>
          </div>
        )}
        <div>
          <div className='px-2 py-3' style={{borderBottom: '1px solid #dee2e6'}}>
            <span className='fw-bold'>Docente:</span> {reports?.nombre}
          </div>
          <TableReport subjects={reports?.subjects} setShowReportDetail={setShowReportDetail} setReport={setReport} loading={loading}/>
        </div>
        <ModalReportDetail show={showReportDetail} report={report} onHide={setShowReportDetail}/>
    </div>
  )
}

export default ReportTeacher